import { render, staticRenderFns } from "./ReportBalance.vue?vue&type=template&id=96ca9d9c"
import script from "./ReportBalance.vue?vue&type=script&lang=js"
export * from "./ReportBalance.vue?vue&type=script&lang=js"
import style0 from "./ReportBalance.vue?vue&type=style&index=0&id=96ca9d9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports